import styles from './styles.scss';
import cn from 'classnames';
import { range, NO_ELEMENT } from 'utils';
import { IconStar } from 'components/Shared/Icon/themes/BGH-RD3/iconStar';

interface OwnProps {
  score?: number;
  className?: string;
  containerClassName?: string;
  color?: string;
  emptyStarColor?: string; //color for "empty" stars
}

const AMOUNT_OF_STARS = 4;
const REVIEW_ROUND_FACTOR = 2;

interface IsHalfProps {
  score: number;
  current: number;
}

const isHalf = ({ score, current }: IsHalfProps) => {
  const remainder = score - current;
  const HALF = 0.5;
  return remainder === HALF;
};

export const StarRating = ({
  score,
  className,
  containerClassName,
  color,
  emptyStarColor
}: OwnProps) => {
  const gradientId = color && emptyStarColor ? `gradient-${color}-${emptyStarColor}` : undefined;

  if (score === undefined || score <= 0) {
    return NO_ELEMENT;
  }

  const stars = range(0, AMOUNT_OF_STARS).map((i: number) => {
    const roundedScore = Math.round(score * REVIEW_ROUND_FACTOR) / REVIEW_ROUND_FACTOR;

    return (
      <IconStar
        isHalf={isHalf({ score: roundedScore, current: i })}
        key={i}
        size="small"
        className={cn(className, i < roundedScore ? styles.yellow : styles.grey)}
        color={i < roundedScore ? color : undefined}
        emptyStarColor={emptyStarColor}
        gradientId={gradientId}
      />
    );
  });

  return <div className={cn(containerClassName, styles.starContainer)}>{stars}</div>;
};
